module.exports = __webpack_public_path__ + "static/media/fomites.f3fc56b4.jpg";